export default __webpack_public_path__ + "b9f53474c07414af721ae8d9f9717e56.png";